<div class="card mb-4">
  <div class="card-body pb-5">
    <div class="d-flex justify-content-between flex-row flex-wrap gap-3 mb-4">
      <div class="card-title mb-0 d-flex align-items-center">
        <h4 class="mb-0">Contacts</h4>
      </div>
      <button type="button" class="btn btn-primary" (click)="openContactForm()">
        <fa-duotone-icon icon="pen-to-square" secondaryOpacity="0.9" class="d-none d-sm-inline" />
        Add / Edit
      </button>
    </div>

    @if (!hasContacts()) {
      <div class="text-center text-muted py-4">
        <fa-duotone-icon icon="address-book" secondaryOpacity="0.3" class="fs-1 d-block mb-2"></fa-duotone-icon>
        <p class="mb-1">{{ OrganizationsMessagingConstants.ORGANIZATIONS_NO_CONTACTS_TITLE() }}</p>
        <p class="small mb-0">{{ OrganizationsMessagingConstants.ORGANIZATIONS_NO_CONTACTS_HELP() }}</p>
      </div>
    } @else {
      <div class="d-flex flex-column gap-3">
        @for (contact of contacts(); track contact.organizationContactId) {
          <div class="border rounded-3 px-3 py-2 d-flex justify-content-between align-items-center">
            <div class="d-flex align-items-center">
              <div class="list-row-icon me-4">
                <fa-duotone-icon [icon]="contactTypeIcon(contact.type)" secondaryOpacity="0.5" class="fs-1 text-primary"></fa-duotone-icon>
              </div>
              <div class="d-flex flex-column">
                <span class="fw-bold">{{ contact.name }}</span>
                @if (hasEmail(contact)) {
                  <small class="text-muted">{{ contact.emailAddress }}</small>
                }
                @if (hasPhoneNumber(contact)) {
                  <small class="text-muted">
                    {{ contact.phoneCountryCode | CountryCode }}
                    {{ contact.phoneNumber | NANPFormattedPhone }}
                    @if (hasPhoneExtension(contact)) {
                      {{ contact.phoneExtension | PhoneExtension }}
                    }
                  </small>
                }
              </div>
            </div>
            <button type="button" class="btn btn-outline-danger btn-sm" (click)="openRemoveConfirmation(contact)">
              Remove
            </button>
          </div>
        }
      </div>
    }
  </div>
</div>

<ms-organization-contact-form-modal
  #contactFormModal
  [organization]="organization()"
  (contactSaved)="onContactSaved($event)"
  (contactSaveFailed)="onContactSaveFailed($event)">
</ms-organization-contact-form-modal>

<ms-confirmation-modal
  #removeContactModal
  modalId="removeContactModal"
  confirmButtonText="Remove"
  cancelButtonText="Cancel"
  confirmButtonClassName="btn-danger"
  (confirmed)="confirmRemoveContact()"
  (cancelled)="cancelRemoveContact()"
  [isSubmitting]="isSubmitting()">
</ms-confirmation-modal>

<ms-info-modal
  #contactInfoModal
  modalId="contactInfoModal"
  (onConfirm)="closeInfoModal()">
</ms-info-modal>
